class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onCartFeedbackVisible = this.handleCartFeedbackVisible.bind(this);
    this.pendingCartIconHtml = null;

    window.addEventListener('cn:cart-feedback-visible', this.onCartFeedbackVisible);

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState?.sections?.[section.id];

      if (!target || !sectionHtml) return;

      const innerHtml = this.getSectionInnerHTML(
        sectionHtml,
        section.selector,
        section.id
      );

      if (innerHtml === null) return;

      if (section.id === 'cart-icon-bubble') {
        this.pendingCartIconHtml = innerHtml;
        return;
      }

      target.innerHTML = innerHtml;
    });

    /*
      Falls das Feedback im seltenen Fall bereits sichtbar wurde, bevor die
      Section-Antwort vollstÃ¤ndig verarbeitet war, sofort nachziehen.
    */
    if (
      this.pendingCartIconHtml !== null &&
      Date.now() - Number(window.cnCartFeedbackVisibleAt || 0) < 1500
    ) {
      this.applyPendingCartIcon();
    }

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', sectionId = '') {
    if (!html) return null;

    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');

    /*
      Manche Theme-Versionen liefern beim Cart-Icon den kompletten Link,
      andere nur dessen Inhalt innerhalb des Shopify-Section-Wrappers.
      In beiden FÃ¤llen darf nur der Inneninhalt in den vorhandenen Header-Link.
    */
    if (sectionId === 'cart-icon-bubble') {
      const returnedCartLink = parsedDocument.getElementById('cart-icon-bubble');

      if (returnedCartLink) {
        return returnedCartLink.innerHTML;
      }

      const sectionWrapper = parsedDocument.querySelector('.shopify-section');

      if (sectionWrapper) {
        return sectionWrapper.innerHTML;
      }

      return parsedDocument.body.innerHTML.trim() || null;
    }

    const source = parsedDocument.querySelector(selector);

    return source ? source.innerHTML : null;
  }

  handleCartFeedbackVisible() {
    this.applyPendingCartIcon();
  }

  applyPendingCartIcon() {
    if (this.pendingCartIconHtml === null) return;

    const target = document.getElementById('cart-icon-bubble');

    if (!target) return;

    target.innerHTML = this.pendingCartIconHtml;
    this.pendingCartIconHtml = null;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}